import React from "react";
import { TagChip } from "../TagChip";
import { SmallBadge } from "./SoonBadge.styles";

export const SOON_TOOLTIP = "Coming soon";
/** The default badge text. One coming-soon wording app-wide. */
export const SOON_LABEL = "Coming soon";
/** Marks a Coming-soon feature that shows sample data instead of the viewer's own. */
export const SAMPLE_LABEL = "Sample data · Coming soon";
export interface SoonBadgeProps {
  label?: string;
  /** Opt-in `sm`: the compact 20px `.soon` pill (11px semibold, TagChip `subtle`). Default `md`: the peach TagChip `soon` look, xs. */
  size?: "md" | "sm";
  className?: string;
}

/** A feature shown but not built yet: the peach TagChip `soon` look (F23), 18px. Pair it with a disabled control and a Tooltip (SOON_TOOLTIP). */
export const SoonBadge: React.FC<SoonBadgeProps> = ({ label = SOON_LABEL, size = "md", className }) => {
  if (size === "sm") {
    return <SmallBadge forwardedAs="span" testId="soon-badge" showTitle={false} label={label} tone="subtle" className={className} />;
  }
  return <TagChip as="span" testId="soon-badge" showTitle={false} label={label} tone="soon" size="xs" className={className} />;
};
